import log from './log'
import statistics from './statistics'
import shareLinkStatistics from './shareLinkStatistics'
import cardFrameMonitor from './cardFrameMonitor'
import messageMonitoring from './messageMonitoring'
import channelClassification from './channelClassification'
import cardFrameDetails from './cardFrameDetails'
export default {
  namespaced: true,
  modules: {
    log,
    statistics,
    shareLinkStatistics,
    cardFrameMonitor,
    messageMonitoring,
    channelClassification,
    cardFrameDetails,
  },
}
